module.exports = __webpack_public_path__ + "46d6122e07b429675bb2b01e2fe60e46.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/von-talin.png
// module id = YvKU
// module chunks = 0